export enum SearchQueryTermType {
  CRITERION = 'CRITERION',
  OPERATOR = 'OPERATOR',
  GROUP_START = 'GROUP_START',
  GROUP_END = 'GROUP_END',
}

export type SearchQueryTermWithoutPositions = Omit<
  SearchQueryTerm,
  'startPosition' | 'endPosition'
>;

export type SearchQueryTerm = {
  type: SearchQueryTermType;
  value: string;
  startPosition: number;
  endPosition: number;
};

export type RecentSearch = {
  id: string;
  terms: SearchQueryTermWithoutPositions[];
};

export type FieldResult = {
  id: string;
  value: string;
};
